import React from 'react';
import { NewPage, NewPageProps } from '../../../components/NewPage';
import { isPollsSite } from '../../../utils/location';

interface ContentWrapperProps extends NewPageProps {}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({ children, ...props }) => {
  if (isPollsSite()) {
    return <NewPage {...props}>{children}</NewPage>;
  }

  return children;
};
